export function getPromotionPerTransaction(total, discount) {
  let price = total
  const filterItem = discount?.filter(v => v.type?.toLowerCase() === 'transaction') || []
  for (const item of filterItem) {
    if (!isValidTransactionItem(item)) continue
    for (const gift of item.gift) {
      price = applyDiscount(price, gift)
      price = Math.max(0, price)
    }
  }
  return price
}

export function getmappingTransaction(total, discount, id) {
  let price = total
  const result = []
  const filterItem = discount.filter(v => v.type?.toLowerCase() === 'transaction')
  for (const item of filterItem) {
    if (!isValidTransactionItem(item)) continue
    for (const gift of item.gift) {
      const newPrice = applyDiscount(price, gift)
      const discountAmount = price - newPrice
      const finalPrice = Math.max(0, newPrice)
      const finalDiscount = price - finalPrice
      result.push({
        promotion_id: item.promotion_id,
        discount: finalDiscount,
        price: finalPrice,
      })
      price = finalPrice
    }
  }
  return result
}

function isValidTransactionItem(item) {
  const validAttributes = ['pronas', 'prolok', 'proloc', 'prodis']
  const validTiers = [1, 2, 3]
  return item.type?.toLowerCase() === 'transaction' &&
    (item.is_principal === true || item.is_principal === false) &&
    validAttributes.includes(item.attribute?.toLowerCase()) &&
    validTiers.includes(item.tier)
}

function applyDiscount(price, gift) {
  if (gift.value_type?.toLowerCase() === 'percentage') {
    const discount = Math.round(price * (gift.value / 100))
    const maxDiscount = gift.max_value !== 0 ? Math.min(discount, gift.max_value) : discount
    return price - maxDiscount
  } else if (gift.value_type?.toLowerCase() === 'fixed') {
    return price - Number(gift.value)
  }
  return price
}
